import { buildRoute } from "@u/routes";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/**
 * Inline alert next to a product card title (TourCard/VenueCard) — signals the
 * resource has `count` incomplete-data avisos. Amber icon + count, no chrome, so
 * it sits beside the name. Clicking jumps to /dashboard/health pre-filtered to
 * this resource. Renders nothing when count is 0.
 */
export default function HealthAlertBadge({
  count,
  resourceId,
}: {
  count: number;
  resourceId?: string;
}) {
  const { t } = useTranslation();
  if (!count) return null;
  const label = t("health.card_alert", { count });
  const content = (
    <>
      <AlertTriangle size={13} strokeWidth={2} aria-label={label} />
      <span className="text-xs font-mono leading-none">{count}</span>
    </>
  );
  const cls =
    "inline-flex items-center gap-0.5 shrink-0 text-warning hover:text-warning-strong transition-colors";
  if (!resourceId) {
    return (
      <span className={cls} title={label}>
        {content}
      </span>
    );
  }
  return (
    <Link
      to={buildRoute.health(resourceId)}
      title={label}
      onClick={(e) => e.stopPropagation()}
      className={cls}
    >
      {content}
    </Link>
  );
}
